import React from 'react';
import Button, { ButtonToneProps } from 'src/components/ui/Button/Button';
import { useTranslation } from 'react-i18next';
import ContainerHead from 'src/components/ui/ContainerOverlay/ContainerHead/ContainerHead';
import { SaleOrder } from 'src/services/saleOrder';
import OverlayNavArrows from 'src/components/layouts/OverlayNavArrows/OverlayNavArrows';
import { FulfillmentStateKeys } from '../../../../utils/general';

export interface HeadProps {
  showSelectProducts: boolean;
  edit?: boolean;
  saleOrder?: SaleOrder;
  setEdit: (edit: boolean) => void;
  handleAction: (action: 'cancel' | 'save') => void;
  setShowSelectProducts: (showSelectProducts: boolean) => void;
  allowEdition?: boolean;
  allowAddressConfirmEdit?: boolean;
  isValid?: boolean;
  extraActions?: React.ReactNode;
}

const Head: React.FC<HeadProps> = ({
  showSelectProducts,
  saleOrder,
  edit,
  setEdit,
  handleAction,
  setShowSelectProducts,
  allowEdition,
  allowAddressConfirmEdit,
  isValid = true,
  extraActions,
}) => {
  const { t } = useTranslation();
  return (
    <ContainerHead>
      <Button
        icon="keyboard-tab-right"
        onClick={() => handleAction('cancel')}
        tone={ButtonToneProps.DESTRUCTIVE_TRANSPARENT}
      />
      {showSelectProducts && <h3 className="typo-text-16--bold text-full truncate">{t('general.add_products')}</h3>}
      {!showSelectProducts && saleOrder && (
        <h3 className="typo-text-16--bold text-full truncate">
          {saleOrder.name} | {saleOrder.id}
        </h3>
      )}
      {showSelectProducts ? (
        <div className="ml-auto">
          <Button icon="close" onClick={() => setShowSelectProducts(false)} tone={ButtonToneProps.SECONDARY} />
        </div>
      ) : (
        <>
          <OverlayNavArrows />
          <div className="ml-auto flex items-center gap-x-12">
            {extraActions}
            {!edit && allowEdition && (
              <Button
                disabled={
                  !saleOrder?.is_editable ||
                  (saleOrder?.fulfillment_state.key !== FulfillmentStateKeys.draft && !allowAddressConfirmEdit)
                }
                onClick={() => setEdit(true)}
                title={t('general.edit')}
                tone={ButtonToneProps.PRIMARY_BLUE}
              />
            )}
            {edit && (
              <div className="flex items-center gap-x-8">
                <Button
                  onClick={() => handleAction('cancel')}
                  title={t('general.cancel')}
                  tone={ButtonToneProps.SECONDARY}
                />
                <Button
                  onClick={() => handleAction('save')}
                  title={t('general.save')}
                  tone={ButtonToneProps.PRIMARY_BLUE}
                  disabled={!isValid}
                />
              </div>
            )}
          </div>
        </>
      )}
    </ContainerHead>
  );
};

export default Head;
